import { defineStore } from "pinia"
import { ref, onMounted, watch } from "vue"
import { useRoute } from "vue-router"
import { useAuthStore } from '@/store/auth'
import { Route, SubRoute } from '@/types/auth'
import { getRoutes } from '@/core/data/routes'
import { port, requestType, serverIP } from '@/core/data/config'
import axios from 'axios'

interface searchdatas {
  icon: string
  icon2: string
  path: string
  title: string
}
interface search {
  icon: string
  icon2: string
  path: string
  title: string
  bookmark: string
}

export const useMenuStore = defineStore('menu', () => {
  const route = useRoute()
  const authStore = useAuthStore()

  const data = ref<Route[]>([])
  const togglesidebar = ref<boolean>(true)
  const searchData = ref<searchdatas[]>([])
  const active = ref<boolean>(false)
  const customizer = ref<string>('')
  const searchDatas = ref<search[]>([])
  const searchOpen = ref<boolean>(false)
  const hideRightArrowRTL = ref<boolean>(false)
  const hideLeftArrowRTL = ref<boolean>(true)
  const hideRightArrow = ref<boolean>(true)
  const hideLeftArrow = ref<boolean>(true)
  const width = ref<number>(0)
  const height = ref<number>(0)
  const margin = ref<number>(0)
  const menuWidth = ref<number>(0)
  const perentName = ref<string>('')
  const subName = ref<string>('')
  const childName = ref<string>('')
  const bodyToggle = ref(false)
  const perentToggle = ref<boolean>(false)
  const subToggle = ref<boolean>(false)
  const childToggle = ref<boolean>(false)
  const openSection = ref<boolean>(false)

  watch(() => route.path, () => { updateActiveState() }, { immediate: true })

  onMounted(() => {
    if (window.innerWidth < 991) {
      togglesidebar.value = false
    }
  })

  async function loadMenu() {
    const routes = getRoutes(authStore.user?.rol ?? '')

    const { data: reqData } = await axios.get(`${requestType}://${serverIP}:${port}/rutas/rutas`, {
      params: {
        token: authStore.token
      },
    })

    const subRoutes = reqData.rutas
    const subMenuItems: SubRoute[] = []

    authStore.sites.clear()

    for (const site in subRoutes) {
      const subItems: SubRoute[] = []

      for (const item of subRoutes[site]) {
        subItems.push(new SubRoute(item.label, `/monitoring/${item.id}`))
      }

      subMenuItems.push(new SubRoute(site, 'monitoring', subItems))
      authStore.sites.add(site)
    }

    const monitoringItems = routes.find(item => item.id === 'monitoring')

    if (monitoringItems) {
      monitoringItems.children = subMenuItems
    }

    data.value = routes

    return data.value
  }

  function toggleMenu(item: Route|SubRoute) {
    if (!item.active) {
      for (const menu of data.value) {
        if (item instanceof Route && data.value.includes(item)) {
          menu.active = false
        }

        if (menu.children) {
          for (const subMenu of menu.children) {
            subMenu.active = false

            if (subMenu.children) {
              for (const child of subMenu.children) {
                child.active = false

                if (child.children) {
                  for (const subchild of child.children) {
                    subchild.active = false
                  }
                }
              }
            }
          }
        }
      }
    }

    if (item.children) {
      item.active = !item.active
    }
  }

  function toggleSidebar() {
    togglesidebar.value = !togglesidebar.value;
  }

  function updateActiveState() {
    const pathSegments = route.path.split('/')
    const basePath = pathSegments.length > 3 ? `/${pathSegments[1]}/${pathSegments[2]}` : route.path

    for (const item of data.value) {
      item.active = item.path === basePath

      if (item.children) {
        for (const subItem of item.children) {
          subItem.active = false

          if (subItem.path && subItem.path === basePath) {
            item.active = true
            subItem.active = true
          }

          if (subItem.children) {
            for (const childItem of subItem.children) {
              childItem.active = false

              if (childItem.path === basePath) {
                item.active = true
                subItem.active = true
                childItem.active = true
              }
            }
          }
        }
      }
    }
  }

  return {
    data,
    loadMenu,
    toggleMenu,
    togglesidebar,
    toggleSidebar,
    customizer,
    searchData,
    searchOpen,
    hideRightArrowRTL,
    hideLeftArrowRTL,
    hideRightArrow,
    hideLeftArrow,
    width,
    height,
    margin,
    menuWidth,
    searchDatas,
    bodyToggle,
    perentName,
    subName,
    childName,
    perentToggle,
    subToggle,
    childToggle,
    active,
    updateActiveState,
    openSection
  }
})